import Avatar from "../../../../../Assets/Icons/AI_Studio/Avatar.svg";
import AvatarWhite from "../../../../../Assets/Icons/AI_Studio/Avatar-white.svg";
import Brush from "../../../../../Assets/Icons/AI_Studio/Brush/brush.svg";
import Brush_1 from "../../../../../Assets/Icons/AI_Studio/Brush/brush-1.svg";
import Brush_2 from "../../../../../Assets/Icons/AI_Studio/Brush/brush-2.svg";
import Brush_3 from "../../../../../Assets/Icons/AI_Studio/Brush/brush-3.svg";
import Icon_1 from "../../../../../Assets/Icons/AI_Studio/Avatars/0.svg";
import Icon_2 from "../../../../../Assets/Icons/AI_Studio/Avatars/1.svg";
import Icon_3 from "../../../../../Assets/Icons/AI_Studio/Avatars/2.svg";
import Icon_4 from "../../../../../Assets/Icons/AI_Studio/Avatars/3.svg";
import Icon_5 from "../../../../../Assets/Icons/AI_Studio/Avatars/4.svg";
import Icon_6 from "../../../../../Assets/Icons/AI_Studio/Avatars/5.svg";
import Icon_7 from "../../../../../Assets/Icons/AI_Studio/Avatars/6.svg";
import Icon_8 from "../../../../../Assets/Icons/AI_Studio/Avatars/7.svg";
import Icon_9 from "../../../../../Assets/Icons/AI_Studio/Avatars/8.svg";
import Icon_10 from "../../../../../Assets/Icons/AI_Studio/Avatars/9.svg";

export const MB = 1024 * 1024;

export const NanoBananaModel = {
  NanoBanana2: "nano_banana_2",
};

export const FluxModel = {
  Ultimate: "flux_pro_ultimate",
  Pro: "flux_pro",
  Dev: "flux_dev",
  FluxKontext: "flux_kontext",
};

export const WeddinglyModel = {
  StudioV1: "weddinglyai_studio_v1",
  StudioV2: "weddinglyai_studio_v2",
  StudioV2Plus: "weddinglyai_studio_v2_plus", // only for highlight and swap V2
  StudioV2FullBody: "weddinglyai_studio_v2_fullBody", //not really a model, we will add Full Body. in prompt prefix
  Swift: "runware_ai", // deprecated, keep for backward compatibility
};

export const IdeogramModel = {
  Ideogram2: "ideogram_2",
  IdeogramTurbo: "ideogram_turbo", // deprecated, keep for backward compatibility
  Ideogram3: "ideogram_3",
};

export const normalizeApiModelName = (modelName) => {
  if (modelName === IdeogramModel.IdeogramTurbo) {
    return IdeogramModel.Ideogram3;
  }

  if (
    modelName === WeddinglyModel.Swift ||
    modelName === WeddinglyModel.StudioV1 ||
    modelName === WeddinglyModel.StudioV2 ||
    modelName === WeddinglyModel.StudioV2Plus ||
    modelName === WeddinglyModel.StudioV2FullBody
  ) {
    return FluxModel.Dev;
  }

  return modelName;
};

// cost of each model in credit
export const CreditCostMap = {
  [FluxModel.FluxKontext]: 5,
  [FluxModel.Ultimate]: 10,
  [FluxModel.Pro]: 5,
  [FluxModel.Dev]: 1,
  [IdeogramModel.Ideogram2]: 10,
  [IdeogramModel.IdeogramTurbo]: 5,
  [IdeogramModel.Ideogram3]: 5,
  [NanoBananaModel.NanoBanana2]: 5,
  others: 1,
};

export const AITools = {
  HighlightAndSwap: "HL_AND_SWAP",
  SwapFace: "SWAP_FACES",
  RemoveBackground: "REMOVE_BG",
  BlurBackground: "BLUR_BG",
  FaceCorrection: "FACE_FIX",
  HighlightAndRemove: "HL_AND_REMOVE",
  HighlightAndSwap2: "HL_AND_SWAP_V2", // only for differentiating purpose, but when sending to server, will use regular hlns
  AvatarConverter: "AVATAR",
};

export const MapSelectedAITools = {
  [AITools.HighlightAndSwap]: {
    title: "Highlight and Swap",
    description: "Select an area and generate",
    iconClassName: "fas fa-highlighter",
  },
  [AITools.SwapFace]: {
    title: "Swap Faces",
    description: "Select faces and swap them",
    iconClassName: "fas fa-user-edit",
  },
  [AITools.RemoveBackground]: {
    title: "Remove Background",
    description: "Background will be removed",
    iconClassName: "fas fa-eraser",
  },
  [AITools.BlurBackground]: {
    title: "Blur Background",
    description: "The background will be blurred",
    iconClassName: "fas fa-tint-slash",
  },
  [AITools.FaceCorrection]: {
    title: "Face Correction",
    description: "Select faces and swap them",
    iconClassName: "fas fa-user-check",
  },
  [AITools.HighlightAndRemove]: {
    title: "Highlight and Remove",
    description: "Select an area to remove it",
    iconClassName: "fas fa-cut",
  },
  [AITools.HighlightAndSwap2]: {
    title: "Highlight and Swap 2",
    description: "Select an area and generate",
    iconClassName: "fas fa-highlighter",
  },
  [AITools.AvatarConverter]: {
    title: "Avatar Converter",
    description: "Turn image into avatar",
    iconClassName: Avatar,
    iconClassNameSelector: AvatarWhite,
    isImage: true,
  },
};

export const ModelOptions = [
  {
    value: FluxModel.Dev,
    label: "WeddinglyAi Swift (1 Credit)",
    shortLabel: "WeddinglyAi Swift",
    creditsLabel: "(1 Credit)",
    description:
      "Fast creation (3 seconds).High resolution, versatile images that fit almost any idea.",
    supportsAspectRatio: true,
  },
  {
    value: FluxModel.Pro,
    label: "WeddinglyAi Pro (5 Credits)",
    shortLabel: "WeddinglyAi Pro",
    creditsLabel: "(5 Credits)",
    description:
      "Detailed creation (10 seconds). Photorealist ic images that look like real wedding photos.",
    supportsAspectRatio: true,
  },
  {
    value: NanoBananaModel.NanoBanana2,
    label: "WeddinglyAi Smart (5 Credits)",
    shortLabel: "WeddinglyAi Smart",
    creditsLabel: "(5 Credits)",
    description:
      "Detailed creation (10 seconds). Follows detailed prompts closely, great for complex scenes.",
    supportsAspectRatio: true,
  },
  {
    value: IdeogramModel.Ideogram3,
    label: "WeddinglyAi Text (5 Credits)",
    shortLabel: "WeddinglyAi Text",
    creditsLabel: "(5 Credits)",
    description:
      "Detailed creation (5 seconds). Sharp, readable text for invitations, signs, and logos.",
    supportsAspectRatio: true,
  },
  {
    value: FluxModel.FluxKontext,
    label: "WeddinglyAi Edit (5 Credits)",
    shortLabel: "WeddinglyAi Edit",
    creditsLabel: "(5 Credits)",
    description:
      "Editing (10 seconds). Edit or enhance an existing image with a simple prompt.",
    supportsAspectRatio: true,
  },
  {
    value: FluxModel.Ultimate,
    label: "WeddinglyAi Real (10 Credits)",
    shortLabel: "WeddinglyAi Real",
    creditsLabel: "(10 Credits)",
    description:
      "Premium creation (up to 20 seconds). Ultra-sharp, lifelike detail for print-ready images.",
    supportsAspectRatio: true,
  },
  {
    value: IdeogramModel.Ideogram2,
    label: "WeddinglyAi Vision (10 Credits)",
    shortLabel: "WeddinglyAi Vision",
    creditsLabel: "(10 Credits)",
    description:
      "Premium creation (up to 15 seconds). Artful detail for illustrations, graphics, and text-in-image.",
    supportsAspectRatio: true,
  },
];

export const modelSupportsAspectRatio = (model) =>
  ModelOptions.some(
    (option) => option.value === model && option.supportsAspectRatio,
  );

export const canvasBrushSize = {
  small: 3,
  medium: 6,
  large: 10,
  XLarge: 20,
};

export const CanvasBrushSizeOptions = [
  {
    value: canvasBrushSize.small,
    label: Brush,
  },
  {
    value: canvasBrushSize.medium,
    label: Brush_1,
  },
  {
    value: canvasBrushSize.large,
    label: Brush_2,
  },
  {
    value: canvasBrushSize.XLarge,
    label: Brush_3,
  },
];

export const AvatarStyleIndex = {
  Manga: 0,
  DisneyPixar: 1,
  PopArt: 2,
  Sketch: 3,
  Comic: 4,
  Carton: 5,
  Oil: 6,
  WaterColor: 7,
  Realistic: 8,
  Minimalist: 9,
};

export const AvatarStyleIndexOptions = [
  {
    type: AvatarStyleIndex.Manga,
    name: "Manga",
    icon: Icon_1,
  },
  {
    type: AvatarStyleIndex.DisneyPixar,
    name: "Disney/Pixar",
    icon: Icon_2,
  },
  {
    type: AvatarStyleIndex.PopArt,
    name: "Pop Art",
    icon: Icon_3,
  },
  {
    type: AvatarStyleIndex.Sketch,
    name: "Sketch",
    icon: Icon_4,
  },
  {
    type: AvatarStyleIndex.Comic,
    name: "Comic",
    icon: Icon_5,
  },
  {
    type: AvatarStyleIndex.Carton,
    name: "Carton",
    icon: Icon_6,
  },
  {
    type: AvatarStyleIndex.Oil,
    name: "Oil",
    icon: Icon_7,
  },
  {
    type: AvatarStyleIndex.WaterColor,
    name: "Watercolor",
    icon: Icon_8,
  },
  {
    type: AvatarStyleIndex.Realistic,
    name: "Realistic",
    icon: Icon_9,
  },
  {
    type: AvatarStyleIndex.Minimalist,
    name: "Minimalist",
    icon: Icon_10,
  },
];

export const IdeogramStyleTypeOptions = [
  {
    label: "General",
    value: "GENERAL",
  },
  {
    label: "Realistic",
    value: "REALISTIC",
  },
  {
    label: "Illustration",
    value: "DESIGN",
  },
  {
    label: "Animation",
    value: "ANIME",
  },
  {
    label: "3D",
    value: "RENDER_3D",
  },
];

export const Ideogram3TurboStyleTypeOptions = [
  {
    label: "Realistic",
    value: "REALISTIC",
  },
  {
    label: "General",
    value: "GENERAL",
  },
  {
    label: "Design",
    value: "DESIGN",
  },
];

export const IdeogramColorPaletteOptions = [
  {
    label: "Ember",
    value: "EMBER",
    colorHexes: ["#C82D53", "#31343F", "#CE9167", "#CB625B", "#B0265A"],
  },
  {
    label: "Fresh",
    value: "FRESH",
    colorHexes: ["#EABE81", "#E27C5D", "#3A54EA", "#9FEFA1", "#516DEB"],
  },
  {
    label: "Jungle",
    value: "JUNGLE",
    colorHexes: ["#173F35", "#3A8A68", "#225742", "#398A46", "#0E2420"],
  },
  {
    label: "Magic",
    value: "MAGIC",
    colorHexes: ["#DDB5CF", "#ADA6CC", "#4178A3", "#341F9A", "#EB7496"],
  },
  {
    label: "Melon",
    value: "MELON",
    colorHexes: ["#E1595C", "#70D63D", "#B4D844", "#E8B59E", "#B0311B"],
  },
  {
    label: "Mosaic",
    value: "MOSAIC",
    colorHexes: ["#E0497A", "#335188", "#48A2A5", "#E7B146", "#E48142"],
  },
  {
    label: "Pastel",
    value: "PASTEL",
    colorHexes: ["#EBB6BD", "#BAE3E4", "#F5E9CC", "#CCF4CE", "#DABDF2"],
  },
  {
    label: "Sapphire",
    value: "ULTRAMARINE",
    colorHexes: ["#060A2D", "#0A1260", "#2627F0", "#9AC4DF", "#3F4EF7"],
  },
];

export const Ideogram3TurboColorPaletteOptions = [
  {
    label: "Pastel",
    value: "PASTEL",
    colorHexes: ["#EBB6BD", "#BAE3E4", "#F5E9CC", "#CCF4CE", "#DABDF2"],
  },
  {
    label: "Magic",
    value: "MAGIC",
    colorHexes: ["#DDB5CF", "#ADA6CC", "#4178A3", "#341F9A", "#EB7496"],
  },
  {
    label: "Romantic Blush",
    value: "WD-BLUSH",
    colorHexes: ["#FADCD9", "#F9F1F0", "#D3AB9E", "#A9B388", "#C7B7A3"],
  },
  {
    label: "Navy & Silver",
    value: "WD-NAVY",
    colorHexes: ["#2C3E50", "#BDC3C7", "#ECF0F1", "#95A5A6", "#778DA9"],
  },
  {
    label: "Earthy Terracotta",
    value: "WD-TERRACOTTA",
    colorHexes: ["#E89F71", "#F4F1DE", "#A0937D", "#D57149", "#FFF8E1"],
  },
  {
    label: "Enchanted Forest",
    value: "WD-FOREST",
    colorHexes: ["#1E5128", "#4E6C50", "#B08968", "#DAA520", "#7F5539"],
  },
  {
    label: "Golden Hour",
    value: "WD-GOLDEN",
    colorHexes: ["#FFDAB9", "#FDEBD0", "#FFC0CB", "#FFD700", "#FFF5E1"],
  },
];

export const ImageAspectRatioOptions = [
  {
    label: "1:1",
    value: "1:1",
  },
  {
    label: "3:2",
    value: "3:2",
  },
  {
    label: "3:4",
    value: "3:4",
  },
  {
    label: "2:3",
    value: "2:3",
  },
  {
    label: "16:9",
    value: "16:9",
  },
  {
    label: "9:16",
    value: "9:16",
  },
];

export const ImageAspectRatioOptionsMap = {
  "1:1": {
    text: "Square",
    width: 80,
    height: 80,
  },
  "3:2": {
    text: "Landscape",
    width: 117,
    height: 78,
  },
  "3:4": {
    text: "Portrait",
    width: 84,
    height: 112,
  },
  "2:3": {
    text: "Photo",
    width: 78,
    height: 117,
  },
  "16:9": {
    text: "Full Landscape",
    width: 160,
    height: 90,
  },
  "9:16": {
    text: "Mobile",
    width: 90,
    height: 160,
  },
};
